import { IMediaModel, useIsPlayableWithDate } from "@nf/common";
import React from "react";
import { useTranslation } from "react-i18next";

import Badge from "components/Badge/Badge";

import styles from "./AvailabilityLabel.module.scss";

const config = { dateFormat: "DD. MMM" };

interface AvailabilityLabelProps {
  media: IMediaModel;
}

export const AvailabilityLabel = ({ media }: AvailabilityLabelProps) => {
  const { t } = useTranslation("translations");
  const { isComingSoon, isExpiring, availableFrom, availableTo } =
    useIsPlayableWithDate(media, config);

  if (isExpiring) {
    return (
      <Badge variant="secondary" size="medium" className={styles.label}>
        {t("web_asset_expire")} {availableTo}
      </Badge>
    );
  }

  if (isComingSoon) {
    return (
      <Badge variant="primary" size="medium" className={styles.label}>
        {availableFrom}
      </Badge>
    );
  }

  return null;
};

export default AvailabilityLabel;
